import React, { PureComponent } from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';

import Router from './router';
import store from '../store';

export default class App extends PureComponent {
  render() {
    return (
      <Provider store={store}>
        <Router />
      </Provider>
    );
  }
}

render(<App />, document.getElementById('app'));
